import { createSlice } from '@reduxjs/toolkit';

const isClientSide = typeof window !== 'undefined';

const cartModalSlice = createSlice({
  name: 'cartModalReducer',
  initialState: {
    openItemRemoveConfirmModal: false,
    openItemRemoveSuccessModal: false,
    openAllItemRemoveSuccessModal: false,
    openItemInstallationFeeRemoveModal: false,
    removeableItem: null,
    removeableInstallationFee: null,
    openRemoveUnavailableSuccessModal: false,
    openRemoveUnavailableFailedModal: {
      isOpen: false,
      text: null,
    },
    commonWarningModal: {
      isOpen: false,
      text: null,
    },
  },
  reducers: {
    openConfirmModal: (state, action) => {
      if (action.payload?.type === 'item') {
        state.openItemRemoveConfirmModal = true;
        state.removeableItem = action.payload?.data ?? null;
      }
    },
    closeConfirmModal: (state, action) => {
      if (action.payload?.type === 'item') {
        state.openItemRemoveConfirmModal = false;
        state.removeableItem = action.payload?.data;
        state.openItemRemoveSuccessModal = action.payload?.openSuccess;
      }
    },
    openInstallationConfirmModal: (state, action) => {
      if (action.payload?.type === 'installation') {
        state.openItemInstallationFeeRemoveModal = true;
        state.removeableInstallationFee = action.payload.data;
      }
    },
    closeInstallationConfirmModal: (state, action) => {
      if (action.payload?.type === 'installation') {
        state.openItemInstallationFeeRemoveModal = false;
        state.removeableInstallationFee = null;
      }
    },
    openSuccessModal: (state, action) => {
      if (action.payload?.type === 'item') {
        state.openItemRemoveSuccessModal = true;
        state.removeableItem = state.action?.data;
      }
    },
    closeSuccessModal: (state, action) => {
      if (action.payload?.type === 'item') {
        state.openItemRemoveSuccessModal = false;
        state.removeableItem = null;
      }
    },
    openRemoveAllSuccessModal: (state, action) => {
      if (action.payload?.type === 'all') {
        state.openAllItemRemoveSuccessModal = true;
      }
    },
    closeRemoveAllSuccessModal: (state, action) => {
      if (action.payload?.type === 'all') {
        state.openAllItemRemoveSuccessModal = false;
      }
    },
    openRemoveUnavailableModal: (state, action) => {
      if (action.payload?.type === 'unavailable') {
        state.openRemoveUnavailableSuccessModal = true;
      }
    },
    closeRemoveUnavailableModal: (state, action) => {
      if (action.payload?.type === 'unavailable') {
        state.openRemoveUnavailableSuccessModal = false;
      }
    },
    openCloseUnavailableFailedModal: (state, action) => {
      state.openRemoveUnavailableFailedModal = action.payload;
    },
    openCloseCommonWarningModal: (state, action) => {
      state.commonWarningModal = action.payload;
    },
  },
});

export const {
  openConfirmModal,
  closeConfirmModal,
  openSuccessModal,
  closeSuccessModal,
  openInstallationConfirmModal,
  closeInstallationConfirmModal,
  openRemoveAllSuccessModal,
  closeRemoveAllSuccessModal,
  openRemoveUnavailableModal,
  closeRemoveUnavailableModal,
  openCloseUnavailableFailedModal,
  openCloseCommonWarningModal,
} = cartModalSlice.actions;

export default cartModalSlice.reducer;
